import Swiper, {Navigation, Autoplay, EffectFade} from 'swiper'
Swiper.use([Navigation, Autoplay, EffectFade]);
import BioLogosAnimation from "./BioLogosAnimation";
// import TopoMaskAnimation from "./TopoMaskAnimation";
import HeroTopoPattern2 from "../animation/HeroTopoPattern/HeroTopoPattern2";
import VerticalBioHorizontalScroll from "./VerticalBioHorizontalScroll";

class VerticalBioHealth {

    get defaultOptions() {
        return {
            debug: false,
        }
    }

    constructor(options) {
        this.options = Object.assign({}, this.defaultOptions, options);
        this.init();
    }


    init() {
        this.initSliders();
        this.initTopoPattern();

        let heroWithLogosEl = document.querySelector('[data-hero-with-logos]');
        if (heroWithLogosEl) {
            new BioLogosAnimation();
        }

        const horizontalSlider = document.querySelector('.bh-horizontal-slider');
        if(horizontalSlider){
            new VerticalBioHorizontalScroll(horizontalSlider);
        }
    }

    initSliders() {
        this.timerTime = 500;
        const self = this;

        this.swiperBHHero = new Swiper('.bh-hero-slider', {
            slidesPerView: 1,
            spaceBetween: 0,
            pagination: false,
            allowTouchMove: false,
            watchSlidesProgress: true,
            speed: 1500,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            on: {
                init: function () {
                    setTimeout(() => {
                        if(self.hero){
                            self.hero.resizeScene();
                        }
                    }, 100);

                },
                slideChange(swiper) {
                    const previousSlide = swiper.slides[swiper.previousIndex];
                    const nextSlide = swiper.slides[swiper.activeIndex];
                    const glow = swiper.$el.closest('.bh-hero').children('.bg-glow')

                    glow.removeAttr('class')
                    glow.addClass(nextSlide.dataset.color, 'bg-glow')

                    // if (previousSlide) {
                    //     gsap.fromTo(previousSlide.querySelector('.bh-hero-slide-inner'), {x: 0}, {
                    //         duration: 0.5,
                    //         x: -50,
                    //         ease: "power2.out",
                    //     });
                    // }

                    // gsap.fromTo(nextSlide.querySelector('.bh-hero-slide-inner'), {
                    //     x: 50,
                    // }, {
                    //     duration: 0.5,
                    //     x: 0,
                    //     ease: "power2.out"
                    // });
                }
            }
        });
    }

    initTopoPattern() {
        const mainHero = document.getElementById("hero-topo-pattern-wrapper");
        if (mainHero) {
            this.hero = new HeroTopoPattern2(mainHero);
        }
    }
}

export default VerticalBioHealth;
